module.exports = __webpack_public_path__ + "media/site/images/contact-slider/contact_slideshow-08-aa784e6e67c8a8c341624c770b78b469.jpg";